export default "__VITE_ASSET__ee9312b3__"